// extracted by mini-css-extract-plugin
module.exports = {"deleteRecipeContainer":"DeleteRecipe_deleteRecipeContainer__3fkLL"};